import React, { useState, useEffect, useContext, useMemo } from "react";
import "./companyprofile.scss";
import axios from "axios";
import { useParams } from "react-router";
import Loading from "../../common/loading";
import Breadcrumbs from "../../common/breadcumb";
import Errors from "../../common/error";
import { LangContext } from "../../context/LangContext";
const CompanyProfile = () => {
  const lang = useContext(LangContext);
  const nep = lang.state.np;
  const { slug } = useParams(null);
  const [content, setContent] = React.useState();
  const APIURL = `${process.env.REACT_APP_URL}content/detail/${slug}`;
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        setContent(response.data.detail);
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    })();
  }, [slug]);

  const pageTitle = useMemo(() => {
    switch (slug) {
      case "introduction":
        return nep ? "परिचय" : "Introduction";
      case "capital-structure":
        return nep ? "पुँजी संरचना" : "Capital Structure";
      case "promoters-list":
        return nep ? "प्रवर्तकको सूची" : "Promoters List";
      default:
        return slug;
    }
  }, [slug, nep]);
  const MainData = useMemo(() => {
    if (!content) return [];
    return nep ? content.np : content.en;
  }, [content, nep]);
  if (loading) return <Loading />;
  if (error) return <Errors />;

  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <main className="InsidePageContainer">
        <div className="IntroContainer">
          <div className="wrapper">
            {!MainData ? (
              "No Content Found."
            ) : (
              <div className="IntroFlexbox">
                <div className="IntroContent">
                  <div
                    className="CKContentBox"
                    dangerouslySetInnerHTML={{
                      __html: MainData?.Description,
                    }}
                  ></div>
                </div>
                {MainData.CoverImage ? (
                  <div className="IntroImage">
                     <img src={MainData?.CoverImage} alt={MainData?.cover_alt || MainData?.Title} />
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};
export default CompanyProfile;
